import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-md-12 form-group mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_5 = {
  key: 1,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_6 = {
  key: 2,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_7 = { class: "col-md-12 form-group mb-3" }
const _hoisted_8 = {
  key: 3,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_9 = {
  key: 4,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_10 = {
  key: 5,
  class: "col-md-12 form-group mb-3"
}
const _hoisted_11 = { class: "col-md-12 form-group mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h4", { class: "mb-10 mt-3" }, "Nouvelle Réclamation")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addClaim && _ctx.addClaim(...args)), ["prevent"])),
        class: "row"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "type",
            class: "form-label"
          }, "Type de réclamation *", -1)),
          _createVNode(_component_v_select, {
            label: "name",
            options: _ctx.objects,
            modelValue: _ctx.object,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.object) = $event)),
            class: "custom-select-height"
          }, null, 8, ["options", "modelValue"])
        ]),
        (
            _ctx.object?.name == 'Changement Adresse/Client' ||
            _ctx.object?.name == 'Changement de prix' ||
            _ctx.object?.name == 'Annulation Colis' ||
            _ctx.object?.name == 'Relance Colis/Client' ||
            _ctx.object?.name == 'Rembourssement'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                for: "code",
                class: "form-label"
              }, "Code Colis *", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "code",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkCode())),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.code_colis) = $event)),
                placeholder: "Code d'envoie",
                type: "text",
                class: "form-control"
              }, null, 544), [
                [_vModelText, _ctx.code_colis]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.object?.name == 'Changement de prix')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[13] || (_cache[13] = _createElementVNode("label", {
                for: "price",
                class: "form-label"
              }, "Nouveau prix *", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "price",
                name: "price",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.price) = $event)),
                type: "number",
                min: "0",
                placeholder: "Nouveau prix *",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.form.price]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.object?.name == 'Rembourssement')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[14] || (_cache[14] = _createElementVNode("label", {
                for: "priceRemb",
                class: "form-label"
              }, "Prix à rembourser *", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "priceRemb",
                name: "priceRemb",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.priceRemb) = $event)),
                type: "number",
                min: "0",
                placeholder: "Prix à rembourser *",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.form.priceRemb]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _cache[15] || (_cache[15] = _createElementVNode("label", {
            for: "city",
            class: "form-label"
          }, "Ville *", -1)),
          _createVNode(_component_v_select, {
            class: "custom-select-height",
            modelValue: _ctx.city,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.city) = $event)),
            label: "name",
            options: _ctx.citiesList
          }, null, 8, ["modelValue", "options"])
        ]),
        (_ctx.object?.name == 'Changement Adresse/Client')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[16] || (_cache[16] = _createElementVNode("label", {
                for: "Adresse",
                class: "form-label"
              }, "Nouveau Adresse", -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "Adresse",
                name: "Adresse",
                rows: "2",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.adresse) = $event)),
                placeholder: "Nouveau Adresse",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.form.adresse]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.object?.name == 'Changement Adresse/Client')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "reciever",
                class: "form-label"
              }, "Nouveau Destinataire", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "reciever",
                name: "reciever",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.reciever) = $event)),
                placeholder: "Nouveau Destinataire",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.form.reciever]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.object?.name == 'Changement Adresse/Client')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                for: "phone",
                class: "form-label"
              }, "Nouveau Numéro Téléphone", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "phone",
                name: "phone",
                type: "text",
                pattern: "[0-9]*",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.phone) = $event)),
                placeholder: "Nouveau Numéro Téléphone",
                maxlength: "10",
                class: "form-control"
              }, null, 512), [
                [_vModelText, _ctx.form.phone]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _cache[19] || (_cache[19] = _createElementVNode("label", {
            for: "msg",
            class: "form-label"
          }, "Message *", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "msg",
            name: "msg",
            rows: "2",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.msg) = $event)),
            placeholder: "Message *",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.form.msg]
          ])
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-12" }, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary"
          }, [
            _createElementVNode("span", { class: "text-nowrap" }, "Enregistrer")
          ])
        ], -1))
      ], 32)
    ])
  ]))
}